import { css } from '@emotion/css'

const styles = {
  link: css({
    display: 'inline-flex',
    justifyContent: 'center',
    textDecoration: 'none',
    alignItems: 'center',

    '&[disabled]': {
      opacity: 1,
      pointerEvents: 'auto',
    },
  }),
}

export default styles
